// extracted by mini-css-extract-plugin
export default {"image":"NZ-z","loaded":"OZ-z"};